// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let WizardPriceRangeFields = require("../wizard/WizardPriceRangeFields.bs.js");
let PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.bs.js");

let convertFragment = PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__KeyFacts__Price__PriceRange(props) {
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPricePriceRange_draft_graphql.node, convertFragment, props.draft);
  let draftProperty = draft.draftProperty;
  let match = draftProperty.propertyType;
  let tmp;
  tmp = match === "FOR_SALE" ? "Lower Price" : "Lower Rent/month";
  let match$1 = draftProperty.propertyType;
  let tmp$1;
  tmp$1 = match$1 === "FOR_SALE" ? "Upper Price" : "Upper Rent/month";
  return JsxRuntime.jsx(WizardPriceRangeFields.make, {
    minPrice: props.minPrice,
    maxPrice: props.maxPrice,
    minPriceLabel: tmp,
    maxPriceLabel: tmp$1,
    width: 12,
    widthMd: 4
  });
}

let make = PropertyWizardRelay__KeyFacts__Price__PriceRange;

exports.DraftFragment = DraftFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
